import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
import { onUnmounted, ref } from 'vue';
import events from '../services/EventBus';
import AppAlert from "./AppAlert.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppAlerts',
    props: {
        position: {}
    },
    setup(__props) {
        const alerts = ref([]);
        events.$on('app.alert', add);
        events.$on('app.alert-dismiss', dismiss);
        events.$on('app.alert-clear-all', clearAll);
        onUnmounted(() => {
            events.$off('app.alert', add);
            events.$off('app.alert-dismiss', dismiss);
            events.$off('app.alert-clear-all', clearAll);
        });
        function dismiss(alert) {
            remove(alert);
            alert.onDismiss();
        }
        function clearAll() {
            alerts.value.forEach(dismiss);
        }
        function add(alert) {
            const duplicate = alerts.value.find(a => {
                return a.type === alert.type && a.title === alert.title && a.message === alert.message;
            });
            if (duplicate) {
                remove(duplicate);
            }
            alerts.value.push(alert);
        }
        function remove(duplicate) {
            const index = alerts.value.indexOf(duplicate);
            index > -1 && alerts.value.splice(index, 1);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["app-alerts", 'app-alerts--' + (__props.position ?? 'bottom-left')])
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alerts.value, (alert, index) => {
                    return (_openBlock(), _createBlock(AppAlert, {
                        key: index,
                        alert: alert,
                        onDismiss: dismiss
                    }, null, 8, ["alert"]));
                }), 128))
            ], 2));
        };
    }
});
